export default function datepickerCustomRangePicker() {
  'ngInject';

  return {
    restrict: 'AE',
    scope: {},
    bindToController: {
      rangeStart: '=',
      rangeEnd: '=',
    },
    controller() {},
  };
}
